import { Route, Routes } from 'react-router-dom';

import InventoryValueList from "../../../InventoryValues/InventoryValueList";
import EditInventoryValue from "../../../InventoryValues/EditInventoryValue";
import styled from '@emotion/styled';

const Container = styled.div`
  margin-top: 1.5rem;
`;

const InventoryValues = () => {
  return (
    <Container>
      <Routes>
        <Route path="/values" element={<InventoryValueList category="values" />} />
        <Route path="/values/edit/:id" element={<EditInventoryValue category="values" />} />
        <Route path="/values/edit" element={<EditInventoryValue category="values" />} />
      </Routes>
    </Container>
  );
};

export default InventoryValues;